"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../schema");
const signed = schema_1.Schema.boolean().default(false).interpretation({
    vocab: "basic_health",
    code: "signed_statement_of_consent"
});
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ signed })
    .interpretation({
    vocab: "basic_health",
    code: "patient_statement_of_consent"
});
